"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const models_hook_1 = require("app/models.hook");
const uploadSchema_1 = require("./uploadSchema");
const dataLinkSchema_1 = require("./dataLinkSchema");
const confirmSchema_1 = __importDefault(require("./confirmSchema"));
const completionSchema_1 = __importDefault(require("./completionSchema"));
const auth_1 = require("common/auth");
const firestore_web_1 = require("comodel/firestore-web");
const models_1 = require("app/models");
const firestore_1 = require("comodel/firestore");
const papaparse_1 = require("papaparse");
const parseFile_1 = require("@/utils/parseFile");
const function_client_1 = require("@/utils/function-client");
const standard_1 = require("react-hook-schema/standard");
const components_1 = require("utils/components");
const spreadsheet_1 = require("common/spreadsheet");
const bookParser_1 = require("@/utils/bookParser");
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const ExcelPreview_1 = __importDefault(require("./ExcelPreview"));
const index_1 = require("../../../../index");
const fileToBook_1 = require("../../../../../utils/fileToBook");
const api_1 = require("@/schemaComponents/modules/copilotApi/api");
const schemaComponents_1 = require("@/schemaComponents");
const helpers_1 = require("../helpers");
// Upload as Reference
// Any TRANSLATED texts should be treated as corrected state, and use them as reference translations.
// Upload as Worksheet
// Any TRANSLATED texts should have null or updated state (null for new rows, updated for updated ones).
const getTranslationStatus = ({ uploadMode, isNew, currentStatus, }) => {
    switch (uploadMode) {
        case "reference":
            return "corrected";
        case "worksheet":
            if (isNew) {
                return null;
            }
            return currentStatus === "corrected" ? currentStatus : "updated";
        default:
            return null;
    }
};
function Segment({ segmentId, projectId, }) {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [key, setKey] = (0, react_1.useState)(0);
    const [uploadErrorList, setUploadErrorList] = (0, react_1.useState)([]);
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const { data, loading: segmentDataLoading, set, isEditing, } = (0, models_hook_1.useSegmentDoc)({
        segmentId,
        projectId,
    });
    const { data: projectData, loading: projectDataLoading } = (0, models_hook_1.useProjectDoc)({
        projectId,
    });
    const { list: existingScriptList } = (0, models_hook_1.useReactiveScriptList)({
        projectId,
        segmentId,
    });
    const { list: langList } = (0, models_hook_1.useLangList)({ projectId });
    const langIds = (0, react_1.useMemo)(() => langList === null || langList === void 0 ? void 0 : langList.map((item) => item.langId), [langList]);
    const langAliases = (0, react_1.useMemo)(() => {
        return langList === null || langList === void 0 ? void 0 : langList.reduce((acc, item) => {
            acc[item.langId] = item.aliases || [];
            return acc;
        }, {});
    }, [langList]);
    const toast = (0, standard_1.useToast)();
    const [createdSegmentIds, setCreatedSegmentIds] = (0, react_1.useState)(undefined);
    const [isCreating, setIsCreating] = (0, react_1.useState)(false);
    const [headerData, setHeaderData] = (0, react_1.useState)([]);
    // stale is used to prevent the preview from being rendered after the initial render (set headerData)
    const [stale, setStale] = (0, react_1.useState)(false);
    const alert = (0, standard_1.useAlert)();
    const errorModal = (0, standard_1.useErrorModal)();
    const parameter = {
        title: isEditing ? "翻訳ファイル詳細" : "翻訳ファイル新規作成",
        breadcrumbConfigs: [
            {
                name: "プロジェクト一覧",
                path: (0, index_1.resolveRoute)("LIST_PROJECTS"),
            },
            {
                name: "翻訳ファイル一覧",
                path: (0, index_1.resolveRoute)("LIST_SEGMENTS", { projectId }),
            },
            {
                name: isEditing ? "翻訳ファイル詳細" : "翻訳ファイル新規作成",
            },
        ],
        remove: isEditing
            ? {
                handler: () => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield (0, helpers_1.deleteSegment)(data);
                    }
                    catch (e) {
                        errorModal({
                            error: e,
                            internalMessage: "Error delete segment",
                        });
                    }
                }),
            }
            : undefined,
        steps: [
            {
                title: "ファイルアップロード",
                schema: (0, uploadSchema_1.getUploadSchema)({
                    isEditing,
                    projectId,
                    segmentId,
                    langAliases,
                }),
                next: {
                    condition: (data) => {
                        if (!data.uploadMode)
                            return false;
                        if (!isEditing &&
                            (!data.rawFiles || data.rawFiles.length == 0) &&
                            (!data.multiFile || data.multiFile.length === 0)) {
                            alert({
                                message: "ファイルを選択してください",
                            });
                            return false;
                        }
                        return true;
                    },
                },
            },
            {
                title: "データ紐づけ",
                schema: (0, dataLinkSchema_1.getDataLinkSchema)({
                    isEditing,
                    projectId,
                    segmentId,
                    langAliases,
                    originalScriptFields: headerData,
                }),
                extraSchema: (0, confirmSchema_1.default)(),
                preview: isEditing
                    ? undefined
                    : {
                        title: (react_1.default.createElement("span", null,
                            react_1.default.createElement("p", null, "\u30D7\u30EC\u30D3\u30E5\u30FC\u3092\u8868\u793A"),
                            uploadErrorList.length > 0 && (react_1.default.createElement("p", { className: "text-danger", style: { fontSize: "0.875em" } }, uploadErrorList.map((error, index) => {
                                var _a;
                                return (react_1.default.createElement("div", { key: index }, (_a = error.e) === null || _a === void 0 ? void 0 : _a.render()));
                            }))))),
                        component: ({ control, data, accessorRef }) => {
                            const [selectedCols, setSelectedCols] = (0, react_1.useState)([]);
                            const [headerIndex, setHeaderIndex] = (0, react_1.useState)(data === null || data === void 0 ? void 0 : data.headerRowNumber);
                            const rawFiles = data.rawFiles;
                            const handleSave = (rows, stale) => __awaiter(this, void 0, void 0, function* () {
                                var _a, _b, _c;
                                (_a = accessorRef === null || accessorRef === void 0 ? void 0 : accessorRef.current) === null || _a === void 0 ? void 0 : _a.set(Object.assign(Object.assign({}, data), { headerRowNumber: headerIndex, columnsToSaveOptional: selectedCols }));
                                setHeaderData((_b = rows[data.headerRowNumber - 1]) === null || _b === void 0 ? void 0 : _b.filter((item) => !!item));
                                setStale(stale !== null && stale !== void 0 ? stale : false);
                                // parse to records
                                setUploadErrorList([]);
                                const getPreview = (rawFile) => __awaiter(this, void 0, void 0, function* () {
                                    const bookParser = new bookParser_1.BookParser(Object.assign(Object.assign({}, data), { ignoreLines: data.headerRowNumber !== undefined
                                            ? data.headerRowNumber - 1
                                            : data.ignoreLines !== undefined
                                                ? data.ignoreLines
                                                : 0 }));
                                    const book = yield (0, fileToBook_1.fileToBook)(rawFile);
                                    const records = bookParser.parse(book);
                                    return {
                                        file: rawFile,
                                        fileName: rawFile.name,
                                        records: records.map((record) => {
                                            var _a, _b;
                                            const ret = {
                                                ["ID"]: record.scriptId,
                                                ["テキスト"]: record.text,
                                            };
                                            for (const lang of langList !== null && langList !== void 0 ? langList : []) {
                                                ret[(_a = lang.langName) !== null && _a !== void 0 ? _a : lang.langId] =
                                                    ((_b = record.translations) === null || _b === void 0 ? void 0 : _b[lang.langId]) || "";
                                            }
                                            return ret;
                                        }),
                                    };
                                });
                                let previewRecords = [];
                                if (rawFiles && rawFiles.length > 0) {
                                    try {
                                        previewRecords = yield Promise.all(rawFiles.map(({ file }) => getPreview(file)));
                                        setUploadErrorList([]);
                                    }
                                    catch (e) {
                                        setUploadErrorList((prev) => [
                                            ...prev,
                                            {
                                                message: e.message || "予期せぬエラーが発生しました",
                                                fileName: rawFiles[0].fileName,
                                                e,
                                            },
                                        ]);
                                        return false;
                                    }
                                }
                                (_c = accessorRef === null || accessorRef === void 0 ? void 0 : accessorRef.current) === null || _c === void 0 ? void 0 : _c.set(Object.assign(Object.assign({}, data), { rawFiles: previewRecords }));
                            });
                            const onHeaderRowNumberSelect = () => {
                                var _a;
                                (_a = accessorRef === null || accessorRef === void 0 ? void 0 : accessorRef.current) === null || _a === void 0 ? void 0 : _a.set(Object.assign(Object.assign({}, data), { headerRowNumber: headerIndex, columnsToSaveOptional: selectedCols }));
                            };
                            const onAddScriptIdFormat = (value) => {
                                var _a, _b;
                                if (typeof value !== "string" || !value)
                                    return;
                                const currentFormat = (_a = accessorRef === null || accessorRef === void 0 ? void 0 : accessorRef.current) === null || _a === void 0 ? void 0 : _a.get().scriptIdFormat;
                                const wrappedValue = `{${value}}`;
                                const newValue = !currentFormat
                                    ? wrappedValue
                                    : `${currentFormat}-${wrappedValue}`;
                                (_b = accessorRef === null || accessorRef === void 0 ? void 0 : accessorRef.current) === null || _b === void 0 ? void 0 : _b.set(Object.assign(Object.assign({}, data), { headerRowNumber: headerIndex, columnsToSaveOptional: selectedCols, scriptIdFormat: newValue }));
                            };
                            const onChangeOriginalScriptField = (value) => {
                                var _a;
                                if (typeof value !== "string" || !value)
                                    return;
                                (_a = accessorRef === null || accessorRef === void 0 ? void 0 : accessorRef.current) === null || _a === void 0 ? void 0 : _a.set(Object.assign(Object.assign({}, data), { headerRowNumber: headerIndex, columnsToSaveOptional: selectedCols, originalScriptField: value }));
                            };
                            return (react_1.default.createElement("div", null, rawFiles[0] ? (react_1.default.createElement(ExcelPreview_1.default, { data: data, file: rawFiles[0].file, onRowSelect: (rowIndex) => {
                                    setHeaderIndex(rowIndex);
                                }, onColumnSelect: (columnKeys) => {
                                    setSelectedCols(columnKeys);
                                }, onSave: handleSave, stale: stale, onHeaderRowNumberSelect: onHeaderRowNumberSelect, onAddScriptIdFormat: onAddScriptIdFormat, onChangeOriginalScriptField: onChangeOriginalScriptField })) : (react_1.default.createElement(components_1.Loading, null))));
                        },
                        position: "right",
                    },
                next: {
                    condition: (data) => {
                        return uploadErrorList.length === 0;
                    },
                    handler: (data) => __awaiter(this, void 0, void 0, function* () {
                        const { rawFiles, multiFile, file, segmentName, rawFile } = data, rest = __rest(data, ["rawFiles", "multiFile", "file", "segmentName", "rawFile"]);
                        const execute = (_a) => __awaiter(this, [_a], void 0, function* ({ rawFile, file, segmentName, }) {
                            const _segmentId = data.segmentId || (0, firestore_1.getUniqueId)();
                            if (rawFile) {
                                try {
                                    // MEMO: UploadOption should be a class with a constructor for validation
                                    const uploadOption = {
                                        ignoreLines: data.headerRowNumber !== undefined
                                            ? data.headerRowNumber - 1
                                            : data.ignoreLines !== undefined
                                                ? data.ignoreLines
                                                : 0,
                                        scriptIdFormat: data.scriptIdFormat,
                                        scriptTypeFormat: data.scriptTypeFormat,
                                        translatedScriptFieldFormat: data.translatedScriptFieldFormat,
                                        originalScriptField: data.originalScriptField,
                                        columnsToSave: data.columnsToSave,
                                        columnsToSaveOptional: data.columnsToSaveOptional,
                                        uploadMode: data.uploadMode,
                                        langAliases: langAliases,
                                    };
                                    const bookParser = new bookParser_1.BookParser(uploadOption);
                                    const book = yield (() => __awaiter(this, void 0, void 0, function* () {
                                        try {
                                            if (rawFile &&
                                                rawFile.type ===
                                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                                                return (0, spreadsheet_1.openXLSXBook)(yield (0, parseFile_1.readExcel)(rawFile));
                                            }
                                            else if (rawFile && rawFile.type === "text/csv") {
                                                const text = yield (rawFile === null || rawFile === void 0 ? void 0 : rawFile.text());
                                                return (0, spreadsheet_1.openCSVBook)((0, papaparse_1.parse)(text, {
                                                    delimiter: ",",
                                                    quoteChar: '"',
                                                    skipEmptyLines: "greedy",
                                                }).data);
                                            }
                                            else {
                                                throw new Error("ファイルの形式が正しくないため保存に失敗しました。");
                                            }
                                        }
                                        catch (e) {
                                            throw new Error(e.message || "Invalid file type");
                                        }
                                    }))();
                                    // Handle create records
                                    const records = bookParser.parse(book);
                                    if (!records || !langIds) {
                                        throw new Error("レコードか翻訳言語が見つかりませんでした。");
                                    }
                                    let naiveScripts = [];
                                    const isUpdating = !!segmentId;
                                    if (isUpdating) {
                                        const uploadedScriptIds = records.map((record) => record.scriptId);
                                        // in case of editing
                                        // if script is removed (nonexistent in the uploaded script), remove the row in the DB.
                                        naiveScripts =
                                            (existingScriptList === null || existingScriptList === void 0 ? void 0 : existingScriptList.filter((script) => uploadedScriptIds.includes(script.scriptId))) || [];
                                        const existingScriptIds = naiveScripts === null || naiveScripts === void 0 ? void 0 : naiveScripts.map((script) => script.scriptId);
                                        records.forEach((record) => {
                                            const { scriptId, text, translations } = record;
                                            // case 1: no matched id
                                            if (!(existingScriptIds === null || existingScriptIds === void 0 ? void 0 : existingScriptIds.includes(scriptId))) {
                                                naiveScripts.push(Object.assign(Object.assign({}, record), { translationStatus: langIds === null || langIds === void 0 ? void 0 : langIds.reduce((acc, langId) => {
                                                        acc[langId] = (translations === null || translations === void 0 ? void 0 : translations[langId])
                                                            ? getTranslationStatus({
                                                                uploadMode: data.uploadMode,
                                                                isNew: true,
                                                            })
                                                            : null;
                                                        return acc;
                                                    }, {}) }));
                                                return;
                                            }
                                            const existingScript = existingScriptList === null || existingScriptList === void 0 ? void 0 : existingScriptList.find((script) => script.scriptId === scriptId);
                                            if (!existingScript)
                                                return;
                                            const isTextChanged = existingScript.text !== text;
                                            // if the original text of uploaded row and the script differs
                                            if (isTextChanged) {
                                                // for each languages
                                                for (const langId of langIds) {
                                                    // 1. if translated text is present in the uploaded script,
                                                    if (translations === null || translations === void 0 ? void 0 : translations[langId]) {
                                                        // update the original text and translated text,
                                                        // and update the status, also isTextUpdated set to true.
                                                        naiveScripts = naiveScripts.map((script) => {
                                                            var _a;
                                                            return script.scriptId === existingScript.scriptId
                                                                ? Object.assign(Object.assign({}, script), { text, translations: Object.assign(Object.assign({}, script.translations), { [langId]: translations[langId] }), translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: getTranslationStatus({
                                                                            uploadMode: data.uploadMode,
                                                                            isNew: false,
                                                                            currentStatus: (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId],
                                                                        }) }), isTextUpdated: true }) : script;
                                                        });
                                                    }
                                                    else {
                                                        // 2. if translated text is empty
                                                        // update the original text, and set the status to "更新" (null), also isTextUpdated to true
                                                        naiveScripts = naiveScripts.map((script) => script.scriptId === existingScript.scriptId
                                                            ? Object.assign(Object.assign({}, script), { text, translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: null }), isTextUpdated: true }) : script);
                                                    }
                                                }
                                            }
                                            else {
                                                // if the original text of uploaded row and the script is same
                                                // for each languages
                                                langIds === null || langIds === void 0 ? void 0 : langIds.forEach((langId) => {
                                                    // translation is empty, then do nothing
                                                    if (!(translations === null || translations === void 0 ? void 0 : translations[langId]))
                                                        return;
                                                    // if translation is updated, then update the translation, and update the status
                                                    naiveScripts = naiveScripts.map((script) => {
                                                        var _a;
                                                        return script.scriptId === existingScript.scriptId
                                                            ? Object.assign(Object.assign({}, script), { translations: Object.assign(Object.assign({}, script.translations), { [langId]: translations[langId] }), translationStatus: Object.assign(Object.assign({}, script.translationStatus), { [langId]: getTranslationStatus({
                                                                        uploadMode: data.uploadMode,
                                                                        isNew: false,
                                                                        currentStatus: (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId],
                                                                    }) }) }) : script;
                                                    });
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        // in case of new
                                        naiveScripts = records.map((record) => {
                                            return Object.assign(Object.assign({}, record), { translationStatus: langIds === null || langIds === void 0 ? void 0 : langIds.reduce((acc, langId) => {
                                                    var _a;
                                                    acc[langId] = ((_a = record.translations) === null || _a === void 0 ? void 0 : _a[langId])
                                                        ? getTranslationStatus({
                                                            uploadMode: data.uploadMode,
                                                            isNew: true,
                                                        })
                                                        : null;
                                                    return acc;
                                                }, {}) });
                                        });
                                    }
                                    const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId, segmentId: _segmentId }, {
                                        filter: { segmentId: _segmentId },
                                    });
                                    const preparedScripts = accessor
                                        .prepareUpload(naiveScripts)
                                        .map((record) => (Object.assign({}, record.data)));
                                    try {
                                        yield (0, function_client_1.replaceSegmentSearchDocuments)({
                                            projectId,
                                            segmentId: _segmentId,
                                            scripts: preparedScripts,
                                            endpoint: (0, api_1.getApiEndPoint)(),
                                        });
                                    }
                                    catch (e) {
                                        throw new Error(`${e.message || "サーバーで予期せぬエラーが発生したため保存できませんでした"}`);
                                    }
                                }
                                catch (e) {
                                    return {
                                        success: false,
                                        fileName: (rawFile === null || rawFile === void 0 ? void 0 : rawFile.name) || segmentName,
                                        segmentId: _segmentId,
                                        error: e.message ||
                                            "ファイルのアップロード中にエラーが発生しました",
                                    };
                                }
                            }
                            try {
                                yield set(Object.assign(Object.assign({}, rest), { segmentName,
                                    file, segmentId: _segmentId }));
                            }
                            catch (e) {
                                throw new Error(`${e.message || "サーバーで予期せぬエラーが発生したため保存できませんでした"}`);
                            }
                            return {
                                success: true,
                                fileName: (rawFile === null || rawFile === void 0 ? void 0 : rawFile.name) || segmentName,
                                segmentId: _segmentId,
                            };
                        });
                        if (rawFiles.length === 0 && !file && !segmentName) {
                            throw new Error("ファイルが選択されていません");
                        }
                        const uploadPromises = [];
                        if (file) {
                            uploadPromises.push(execute({
                                rawFile: rawFile,
                                segmentName: segmentName || "",
                                file: file,
                            }));
                        }
                        if (rawFiles && rawFiles.length > 0) {
                            rawFiles.forEach(({ file, fileName }, index) => {
                                var _a, _b;
                                uploadPromises.push(execute({
                                    rawFile: file,
                                    segmentName: fileName,
                                    file: (_b = (_a = data.multiFile) === null || _a === void 0 ? void 0 : _a[index]) !== null && _b !== void 0 ? _b : fileName,
                                }));
                            });
                        }
                        try {
                            setIsCreating(true);
                            setUploadErrorList([]);
                            setCreatedSegmentIds(undefined);
                            const results = yield Promise.all(uploadPromises);
                            const successfulUploads = results.filter((result) => !!(result === null || result === void 0 ? void 0 : result.success));
                            const failedUploads = results.filter((result) => !(result === null || result === void 0 ? void 0 : result.success));
                            if (successfulUploads.length > 0) {
                                setCreatedSegmentIds(successfulUploads.map((upload) => upload.segmentId));
                            }
                            if (failedUploads.length > 0) {
                                setUploadErrorList(failedUploads.map((upload) => ({
                                    message: upload === null || upload === void 0 ? void 0 : upload.error,
                                    fileName: (upload === null || upload === void 0 ? void 0 : upload.fileName) || "",
                                })));
                            }
                            if (successfulUploads.length > 0) {
                                toast({
                                    message: "アップロードが完了しました",
                                    duration: 10000,
                                    type: "success",
                                });
                            }
                            if (failedUploads.length > 0) {
                                toast({
                                    message: "一部のファイルのアップロードに失敗しました",
                                    duration: 10000,
                                });
                            }
                        }
                        catch (error) {
                            toast({
                                message: "アップロード中にエラーが発生しました",
                                duration: 10000,
                            });
                            setUploadErrorList([
                                {
                                    message: error.message || "予期せぬエラーが発生しました",
                                    fileName: "全体のアップロード処理",
                                },
                            ]);
                        }
                        finally {
                            setIsCreating(false);
                        }
                    }),
                },
            },
            {
                title: "新規ファイル作成完了",
                schema: (0, completionSchema_1.default)({
                    isEditing,
                    projectId,
                    segmentId,
                    langAliases,
                }),
                preview: {
                    title: "アップロード結果一覧",
                    position: "after",
                    component: ({ control, data }) => {
                        var _a;
                        const getErrorForFile = (fileName) => {
                            return uploadErrorList.find((error) => error.fileName === fileName);
                        };
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("section", null,
                                react_1.default.createElement(react_bootstrap_1.ListGroup, { variant: "flush" }, (_a = data.rawFiles) === null || _a === void 0 ? void 0 : _a.map((file, index) => {
                                    const error = getErrorForFile(file.fileName);
                                    return (react_1.default.createElement(react_bootstrap_1.ListGroup.Item, { key: index, className: "bg-transparent border-0 py-2" },
                                        react_1.default.createElement("div", { className: "d-flex align-items-start" },
                                            react_1.default.createElement("div", { className: "flex-grow-1" },
                                                react_1.default.createElement("strong", null, file.fileName),
                                                error ? (react_1.default.createElement("div", { className: "text-danger mt-1" },
                                                    error.message,
                                                    error.row && (react_1.default.createElement("small", { className: "text-muted d-block mt-1" },
                                                        "\u884C: ",
                                                        error.row)))) : (react_1.default.createElement("div", { className: "text-success mt-1" }, "\u6B63\u5E38\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F"))))));
                                }))),
                            react_1.default.createElement("section", { className: "d-flex justify-content-center align-items-center mt-4" },
                                react_1.default.createElement("div", null,
                                    react_1.default.createElement("button", { className: "btn btn-primary", onClick: () => {
                                            if (createdSegmentIds &&
                                                createdSegmentIds.length === 1) {
                                                navigate((0, index_1.resolveRoute)("LIST_SEGMENT_SCRIPTS", {
                                                    projectId,
                                                    segmentId: createdSegmentIds[0],
                                                }));
                                            }
                                            else {
                                                navigate((0, index_1.resolveRoute)("LIST_SEGMENTS", {
                                                    projectId,
                                                }));
                                            }
                                        }, style: { marginRight: "10px" } }, "\u7FFB\u8A33\u4F5C\u696D\u3092\u958B\u59CB\u3059\u308B"),
                                    react_1.default.createElement("button", { className: "btn btn-secondary", onClick: () => {
                                            setKey((prevKey) => prevKey + 1);
                                            setUploadErrorList([]);
                                        } }, "\u5F15\u304D\u7D9A\u304D\u30D5\u30A1\u30A4\u30EB\u3092\u65B0\u898F\u4F5C\u6210")))));
                    },
                },
            },
        ],
        backPath: (0, index_1.resolveRoute)("LIST_SEGMENTS", { projectId }),
        edit: segmentId
            ? {
                handler: (data) => __awaiter(this, void 0, void 0, function* () {
                    var _b, _c;
                    return (_c = (_b = parameter.steps[2].next) === null || _b === void 0 ? void 0 : _b.handler) === null || _c === void 0 ? void 0 : _c.call(_b, data);
                }),
            }
            : undefined,
    };
    if (isEditing ? !segmentDataLoading : !projectDataLoading) {
        return (react_1.default.createElement(schemaComponents_1.SchemaFormStepPage, { key: key, data: Object.assign(Object.assign({ createdAt: Date.now(), columnsToSave: projectData.columnsToSave, headerRowNumber: 1, scriptIdFormat: "{row_no}-{sheet_name}", originalScriptField: "text_ja", translatedScriptFieldFormat: "text_{locale}", uploadMode: "worksheet" }, projectData.upload), data), parameter: parameter, loading: (isEditing && segmentDataLoading) || isCreating, header: react_1.default.createElement(standard_1.AdminLocaleSelector, { locales: projectData === null || projectData === void 0 ? void 0 : projectData.availableLocales }), editModeEnabled: true }));
    }
    else {
        return react_1.default.createElement(components_1.Loading, null);
    }
}
// projectData initially has only projectId, and later it will be updated with the data from the server
// createdAt is a required field, so we can use it to check if the data is ready
function isProjectDataReady(data) {
    return !!data.createdAt;
}
exports.default = Segment;
